import React from 'react';
import PageList from '../../templates/PageList';
import PageSearch from '../../molecules/PageSearch';
import PresentationModal from '../../organisms/PresentationModal';
import SoftwarePortfolioTableRows from './SoftwarePortfolioTableRows';
import SoftwarePortfolioModalContent from './SoftwarePortfolioModalContent';
import { useSoftwarePortfolio } from '../../../hooks/useSoftwarePortfolio';

const SoftwarePortfolioPageList: React.FC = () => {
    const {
        showModal,
        modalTitle,
        modalData,
        modalType,
        expandedProjects,
        page,
        pageSize,
        fieldSorted,
        orderSorted,
        searchTerm,
        url,
        API_KEY,
        getCoveragePercentage,
        getGitHubUrl,
        toggleProject,
        openModal,
        pageChanged,
        pageSizeChanged,
        pageSorted,
        searchChanged,
        onFilterClean
    } = useSoftwarePortfolio();

    const renderRows = (rows: any[]) => (
        <SoftwarePortfolioTableRows
            rows={rows}
            expandedProjects={expandedProjects.value}
            getCoveragePercentage={getCoveragePercentage}
            getGitHubUrl={getGitHubUrl}
            toggleProject={toggleProject}
            openModal={openModal}
        />
    );

    return (
        <>
            <PageList
                pageTitle="Portfólio de Software"
                url={url}
                fetchHeaders={[{ key: 'x-api-key', value: API_KEY ?? '' }]}
                breadcrumb={[{ label: 'TI', url: '#' }, { label: 'Portfólio de Software', url: '#' }]}
                tableHeaders={[
                    { id: 'col-name', field: 'name', title: 'Projeto', canSort: true, width: '180px' },
                    { id: 'col-version', field: 'project_version', title: 'Versão', canSort: true, width: '100px' },
                    { id: 'col-domain', field: 'domain', title: 'Domínio', canSort: false, width: '100px' },
                    { id: 'col-language', field: 'language', title: 'Linguagem', canSort: true, width: '140px' },
                    { id: 'col-package-manager', field: 'package_manager', title: 'Gerenciador', canSort: true, width: '100px' },
                    { id: 'col-frameworks', field: 'frameworks', title: 'Frameworks', canSort: false, width: '80px' },
                    { id: 'col-dependencies', field: 'dependencies', title: 'Dependências', canSort: false, width: '90px' },
                    { id: 'col-ignored', field: 'ignored_dirs', title: 'Ignorados', canSort: false, width: '80px' },
                    { id: 'col-coverage', field: 'coverage', title: '% Coverage', canSort: false, width: '100px' },
                    { id: 'col-active', field: 'active', title: 'Ativo', canSort: false, width: '60px' },
                    { id: 'col-repository', field: 'repository', title: '', canSort: false, width: '50px' },
                ]}
                tableFieldSort={fieldSorted as string}
                tableOrderSort={orderSorted as 'ASC' | 'DESC'}
                onTableSort={pageSorted}
                renderRows={renderRows}
                page={Number(page)}
                pageSize={Number(pageSize)}
                onPageChange={pageChanged}
                onItemsPerPageChange={pageSizeChanged}
                defaultBackendHeader={false}
                itemsLabel="repositórios"
            >
                {{
                    filterSlot: (
                        <div className="grid grid-cols-12 gap-1">
                            <PageSearch
                                value={searchTerm}
                                label="Buscar por nome, linguagem, versão..."
                                onSearch={searchChanged}
                                filterCleanVisible={true}
                                filterCleanEnabled={Boolean(searchTerm)}
                                onFilterClean={onFilterClean}
                                configureVisible={false}
                                className="col-span-12"
                            />
                        </div>
                    ),
                    controlSlot: null,
                }}
            </PageList>
            <PresentationModal
                id="repo-details-modal"
                show={showModal.value}
                onClose={() => showModal.value = false}
                header={modalTitle.value}
                height="500px"
            >
                <div className="p-4" style={{ height: '500px', overflowY: 'auto' }}>
                    <SoftwarePortfolioModalContent
                        data={modalData.value}
                        type={modalType.value}
                    />
                </div>
            </PresentationModal>
        </>
    );
};

export default SoftwarePortfolioPageList;
